<template>
  <!-- 消息节点 -->
  <div class="" style="text-align: center">
功能暂未开放
  </div>
</template>

<script>

export default {
  props: {
    data: {

    }
  },
  watch: {
    data: {
      handler() {
        this.init();
      }
    }
  },
  name: "",
  components: {
  },
  data() {
    return {
      nodeInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.nodeInfo = {...this.data};
    },
    // 返回数据，并进行验证
    getData() {
      return this.nodeInfo;
    },
  }
};
</script>

<style lang="scss" scoped>

</style>